import Box from "@mui/material/Box";
import { useState, useEffect } from "react";
import { Button } from "@mui/material";
import axios from "axios";
import Alert from "@mui/material/Alert";
import UpdateImageModal from "./UpdateImageModal";
import { Modal } from "@mui/material";
import { getCompanies } from "../../utils/utilsAPI";

export default function EditAssetModal({
  asset,
  assetTypes,
  assetLocations,
  refreshAssets,
  handleClose,
}) {
  const url = process.env.REACT_APP_URL;
  //Asset
  const [assetName, setAssetName] = useState(asset.assetName);
  const [assetType, setAssetType] = useState(asset.assetTypeId);
  const [assetLocation, setAssetLocation] = useState(asset.locationId);
  const [assetSerial, setAssetSerial] = useState(asset.serialNumber);
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(asset.companyId);

  //Alerts
  const [alert, setAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [disable, setDisable] = useState(false);

  //MODAL
  const [openImageUpdate, setOpenImageUpdate] = useState(false);

  useEffect(() => {
    //Bring in companies
    getCompanies().then((res) => {
      setCompanies(res.companies);
    });
  }, []);

  const handleAlert = (message, severity, close = false, duration = 4000) => {
    setMessage(message);
    setSeverity(severity);
    setAlert(true);
    setTimeout(() => {
      setAlert(false);
      setMessage("");
      setSeverity("");
      setDisable(false);
      if (close) {
        handleClose(false);
        refreshAssets();
      }
    }, duration);
  };

  const handleValidation = async () => {
    setDisable(true);

    if (assetName === "") {
      handleAlert("Please enter an asset name", "warning");
    } else if (assetType === 0) {
      handleAlert("Please select an asset type", "warning");
    } else if (assetLocation === 0) {
      handleAlert("Please select an asset location", "warning");
    } else if (assetType === 29 && assetSerial === "") {
      handleAlert("Please enter an asset serial number", "warning");
    } else if (selectedCompany === 0) {
      handleAlert("Please select a company", "warning");
    } else {
      await handleEditAsset();
    }
  };

  const handleEditAsset = async () => {
    const reqBody = {
      currentUser: localStorage.getItem("userId"),
      currentUsername: localStorage.getItem("username"),
      assetId: asset.assetId,
      assetName: assetName.trim(),
      assetType: assetType,
      locationId: assetLocation,
      assetSerial: assetType == 29 ? assetSerial : "",
      company: selectedCompany,
    };

    await axios
      .post(`${url}/assets/update-asset`, reqBody)
      .then((res) => {
        handleAlert("Asset Successfully Updated", "success", true, 500);
      })
      .catch((err) => {
        console.log(err);
        handleAlert("Something went wrong - please try again", "error");
      });
  };

  return (
    <Box className="edit-asset-modal">
      <section className="edit-asset-section">
        {asset.assetImage && (
          <p
            onClick={() => setOpenImageUpdate(true)}
            className="update-image-btn"
          >
            Update Image
          </p>
        )}
        <h2>Edit Asset</h2>
        <form className="edit-asset-form">
          <div className="form-input">
            <label>Asset Name</label>
            <input
              value={assetName}
              placeholder="Enter Asset Name"
              type="text"
              onChange={(e) => setAssetName(e.target.value)}
              maxLength={50}
            />
          </div>

          <div className="form-input">
            <label>Asset Location</label>
            <select
              value={assetLocation}
              onChange={(e) => {
                setAssetLocation(parseInt(e.target.value));
              }}
            >
              <option value={0}>Select an asset location</option>
              {assetLocations && assetLocations.length > 0
                ? assetLocations.map((l, i) => {
                    return (
                      <option key={i} value={l.locationId}>
                        {l.locationName}
                      </option>
                    );
                  })
                : null}
            </select>
          </div>
          <div className="form-input">
            <label>Asset Type</label>
            <select
              value={assetType}
              onChange={(e) => {
                setAssetType(parseInt(e.target.value));
              }}
            >
              <option value={0}>Select an asset type</option>
              {assetTypes && assetTypes.length > 0
                ? assetTypes.map((a, i) => {
                    return (
                      <option key={i} value={a.assetTypeId}>
                        {a.assetType}
                      </option>
                    );
                  })
                : null}
            </select>
          </div>
          <div className="form-input">
            <label>Company</label>
            <select
              value={selectedCompany}
              onChange={(e) => {
                setSelectedCompany(parseInt(e.target.value));
              }}
            >
              <option value={0}>Select a Company</option>
              {companies && companies.length > 0
                ? companies.map((c, i) => {
                    return (
                      <option key={i} value={c.id}>
                        {c.name}
                      </option>
                    );
                  })
                : null}
            </select>
          </div>

          {assetType == 29 ? (
            <div className="form-input">
              <label>Serial Number</label>
              <input
                type="text"
                onChange={(e) => setAssetSerial(e.target.value)}
                value={assetSerial}
                placeholder="Enter asset serial number"
                maxLength={50}
              />
            </div>
          ) : null}
        </form>
        <section className="alert-section">
          {alert ? <Alert severity={severity}>{message}</Alert> : null}
        </section>
        <section className="btn-section">
          <Button
            variant="contained"
            color="error"
            onClick={() => handleClose(false)}
            disabled={disable}
          >
            Close
          </Button>
          <Button
            variant="contained"
            disabled={disable}
            onClick={handleValidation}
          >
            Update
          </Button>
        </section>
      </section>
      {/* MODALS */}
      <Modal open={openImageUpdate}>
        <UpdateImageModal
          handleCloseOne={setOpenImageUpdate}
          handleCloseTwo={handleClose}
          refreshAssets={refreshAssets}
          asset={asset}
        />
      </Modal>
    </Box>
  );
}
